<app-dialog
  [title]="data.title"
  [actions]="[
  { text: 'Cancel', buttonStyle: 'underline' },
  { text: 'Save', spin : spin, isDisabled: templateName.invalid || textAreaForm.invalid},
]"
  (action)="action($event)"
  (close)="close()"
>
      <div class="amazon-case-template">
        <div class="input-container mb-4">
          <label class="input-container_label" for=""
            >Template Name</label
          >
          <input
            class="input-container_input"
            type="text"
            [formControl]="templateName"
          />
        </div>
        <div class="amazon-case">
         <div class="amazon-case_body">
           <div class="row">
             <div class="col-md-12">
               <div class="amazon-case_header">
                 <div class="amazon-case_header--title d-flex align-items-center justify-content-between w-100">
                     Case Template
                     <div class="d-flex mt-1" [matMenuTriggerFor]="showTemplate">
                      <app-button [buttonSize]="'action'" [buttonStyle]="'text'" >
                        <svg width="10.51" height="12.01"><use xlink:href="assets/images/sprite-icons.svg#clipboard_icon"></use></svg>
                        Add Value
                       </app-button>
                     </div>
                 </div>
             </div> 
               <textarea #textArea class="amazon-case_body--dragarea" [formControl]="textAreaForm">{{templateText}}</textarea>
             </div>
           </div>
         </div>
        </div>
      </div>

      <mat-menu #showTemplate="matMenu">
        <div class="importBoxesMenu" >
            <div class="importBoxesMenu-wrapper">
                <div *ngFor="let item of storeTemplateVar" class="importBoxesMenu-wrapper_tags" cdkDrag (click)="selectTemplate(item)">{{item.name}}</div>
            </div>
        </div>
      </mat-menu>
</app-dialog>
